import ActivityType from "../../entities/activityType";

/**
 * ActivityType actions
 *
 * Call order:
 *
 * ACTIVITYTYPE_SAVE_QUEUE:	adds the item to the save queue
 * --> ACTIVITYTYPE_SAVE:	modifies the state
 * --> ACTIVITYTYPE_SAVE_SUCCESS: if all went well
 * --> ACTIVITYTYPE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail ACTIVITYTYPE_SAVE_QUEUE is during the call to ACTIVITYTYPE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const ACTIVITYTYPE_FETCH_ONE_QUEUE: any = 'ACTIVITYTYPE_FETCH_ONE_QUEUE';
export const ACTIVITYTYPE_FETCH_SUCCESS: any = 'ACTIVITYTYPE_FETCH_SUCCESS';
export const ACTIVITYTYPE_FETCH_FAILURE: any = 'ACTIVITYTYPE_FETCH_FAILURE';
export const ACTIVITYTYPE_FETCH_ONE_SUCCESS: any = 'ACTIVITYTYPE_FETCH_ONE_SUCCESS';
export const ACTIVITYTYPE_FETCH_ONE_FAILURE: any = 'ACTIVITYTYPE_FETCH_ONE_FAILURE';

export const ACTIVITYTYPE_SAVE: any = 'ACTIVITYTYPE_SAVE';
export const ACTIVITYTYPE_SAVE_QUEUE: any = 'ACTIVITYTYPE_SAVE_QUEUE';
export const ACTIVITYTYPE_SAVE_SUCCESS: any = 'ACTIVITYTYPE_SAVE_SUCCESS';
export const ACTIVITYTYPE_SAVE_FAILURE: any = 'ACTIVITYTYPE_SAVE_FAILURE';

export const ACTIVITYTYPE_SAVE_MANY: any = 'ACTIVITYTYPE_SAVE_MANY';
export const ACTIVITYTYPE_SAVE_MANY_QUEUE: any = 'ACTIVITYTYPE_SAVE_MANY_QUEUE';
export const ACTIVITYTYPE_SAVE_MANY_SUCCESS: any = 'ACTIVITYTYPE_SAVE_MANY_SUCCESS';
export const ACTIVITYTYPE_SAVE_MANY_FAILURE: any = 'ACTIVITYTYPE_SAVE_MANY_FAILURE';

export const ACTIVITYTYPE_REMOVE: any = 'ACTIVITYTYPE_REMOVE';
export const ACTIVITYTYPE_REMOVE_QUEUE: any = 'ACTIVITYTYPE_REMOVE_QUEUE';
export const ACTIVITYTYPE_REMOVE_SUCCESS: any = 'ACTIVITYTYPE_REMOVE_SUCCESS';
export const ACTIVITYTYPE_REMOVE_FAILURE: any = 'ACTIVITYTYPE_REMOVE_FAILURE';

export const ACTIVITYTYPE_RESTORE: any = 'ACTIVITYTYPE_RESTORE';
export const ACTIVITYTYPE_RESTORE_QUEUE: any = 'ACTIVITYTYPE_RESTORE_QUEUE';
export const ACTIVITYTYPE_RESTORE_SUCCESS: any = 'ACTIVITYTYPE_RESTORE_SUCCESS';
export const ACTIVITYTYPE_RESTORE_FAILURE: any = 'ACTIVITYTYPE_RESTORE_FAILURE';

export const ACTIVITYTYPE_RESTORE_MANY: any = 'ACTIVITYTYPE_RESTORE_MANY';
export const ACTIVITYTYPE_REMOVE_MANY: any = 'ACTIVITYTYPE_REMOVE_MANY';

/* Fetch actions */
export const fetchActivityTypeSuccess = (activityTypes: ActivityType[], partial: boolean, lastFetch: number) => ({type: ACTIVITYTYPE_FETCH_SUCCESS, activityTypes, partial, lastFetch});
export const fetchActivityTypeFailure = (err: any) => {
		console.error('ActivityTypeAction: fetchActivityTypeFailure', err);
		return {type: ACTIVITYTYPE_FETCH_FAILURE, err};
};
export const fetchOneActivityTypeQueue = (activityTypeId: string) => ({type: ACTIVITYTYPE_FETCH_ONE_QUEUE, activityTypeId});
export const fetchOneActivityTypeSuccess = (activityType: ActivityType) => ({type: ACTIVITYTYPE_FETCH_ONE_SUCCESS, activityType});
export const fetchOneActivityTypeFailure = (id: string, err: any) => {
		console.error('ActivityTypeAction: fetchOneActivityTypeFailure', err);
		return {type: ACTIVITYTYPE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveActivityType = (activityType: ActivityType) => {
    // console.debug('⮂ ACTIVITYTYPE_SAVE action', activityType?.id);
    return {type: ACTIVITYTYPE_SAVE, activityType};
}
export const saveActivityTypeQueue = (activityType: ActivityType) => {
    // console.debug('⮂ ACTIVITYTYPE_SAVE_QUEUE action', activityType?.id);
    return {type: ACTIVITYTYPE_SAVE_QUEUE, activityType};
}
export const saveActivityTypeSuccess = (activityType: ActivityType) => {
    // console.debug('⮂ ACTIVITYTYPE_SAVE_SUCCESS action', activityType?.id);
    return {type: ACTIVITYTYPE_SAVE_SUCCESS, activityType};
}
export const saveActivityTypeFailure = (activityType: ActivityType, status: number, message: string) => {
    console.warn(`⮂ ACTIVITYTYPE_SAVE_FAILURE error saving activityType: HTTP ${status}: ${message}`, activityType?.id);
    return {type: ACTIVITYTYPE_SAVE_FAILURE, activityType, status, message};
};

/* SaveMany actions */
export const saveManyActivityTypes = (activityTypes: ActivityType[]) => {
    // console.debug('⮂ ACTIVITYTYPE_SAVE_MANY action', activityTypes?.map(activityType => activityType?.id).join(','));
    return {type: ACTIVITYTYPE_SAVE_MANY, activityTypes};
}
export const saveManyActivityTypesQueue = (activityTypes: ActivityType[]) => {
    // console.debug('⮂ ACTIVITYTYPE_SAVE_MANY_QUEUE action', activityTypes?.map(activityType => activityType.id).join(','));
    return {type: ACTIVITYTYPE_SAVE_MANY_QUEUE, activityTypes};
}

export const saveManyActivityTypesSuccess = (activityTypes: ActivityType[]) => {
    // console.debug('⮂ ACTIVITYTYPE_SAVE_MANY_SUCCESS action', activityTypes?.map(activityType => activityType.id).join(','));
    return {type: ACTIVITYTYPE_SAVE_MANY_SUCCESS, activityTypes};
}
export const saveManyActivityTypesFailure = (activityTypes: ActivityType[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_ACTIVITYTYPES_FAILURE Error saving activityTypes: HTTP ${status}: ${message}`, activityTypes?.map(activityType => activityType.id).join(','));
		return {type: ACTIVITYTYPE_SAVE_MANY_FAILURE, activityTypes, status, message};
};

/* Remove actions */
export const removeActivityType = (activityType: ActivityType) => ({ type: ACTIVITYTYPE_REMOVE, activityType });
export const removeActivityTypeQueue = (activityType: ActivityType) => ({ type: ACTIVITYTYPE_REMOVE_QUEUE, activityType });
export const removeActivityTypeSuccess = (activityType: ActivityType) => ({ type: ACTIVITYTYPE_REMOVE_SUCCESS, activityType });
export const removeActivityTypeFailure = (activityType: ActivityType, status: number, message: string) => {
	console.error(`Redux: removeActivityTypeFailure Error removing activityType: HTTP ${status}: ${message}`);
	return ({ type: ACTIVITYTYPE_REMOVE_FAILURE, activityType, status, message });
};

/* Restore actions */
export const restoreActivityType = (activityType: ActivityType) => ({ type: ACTIVITYTYPE_RESTORE, activityType });
export const restoreActivityTypeQueue = (activityType: ActivityType) => ({ type: ACTIVITYTYPE_RESTORE_QUEUE, activityType });
export const restoreActivityTypeSuccess = (activityType: ActivityType) => ({ type: ACTIVITYTYPE_RESTORE_SUCCESS, activityType });
export const restoreActivityTypeFailure = (activityType: ActivityType, status: number, message: string) => {
	console.error(`Redux: restoreActivityTypeFailure Error restoring activityType: HTTP ${status}: ${message}`);
	return ({ type: ACTIVITYTYPE_RESTORE_FAILURE, activityType, status, message });
};

/* RestoreMany actions */
export const restoreManyActivityTypes = (activityTypes: ActivityType[]) => ({ type: ACTIVITYTYPE_RESTORE_MANY, activityTypes });

/* RemoveMany actions */
export const removeManyActivityTypes = (activityTypes: ActivityType[]) => ({ type: ACTIVITYTYPE_REMOVE_MANY, activityTypes });